/**
 * Created by rhinov15 on 28/01/2016.
 *
 * UI State where we need to display rulers around the moving selection
 *
 */

import { UiState, UiStateEnum } from "./UiState";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { Utils } from "../../utils/Utils";
import { PlanManager } from "../../../../cocosPlan";
import { math, SavaneConstants, Wall } from "@rhinov/savane-js";

declare var cc: any;

export class RulerState extends UiState {
    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3) {
        super(cursorPosition, cocosPosition);

        // If we need to display the horizontal ruler, create it else remove it
        if (this.horizontalRuler) {
            GameObjectManager.createRuler(false);
        }
        else {
            GameObjectManager.deleteRuler(false);
        }

        // If we need to display the vertical ruler, create it else remove it
        if (this.verticalRuler) {
            GameObjectManager.createRuler(true);
        }
        else {
            GameObjectManager.deleteRuler(true);
        }

        // Draw rulers now
        GameObjectManager.drawRuler(this.cursorPosition);
    }

    // Return value from gloabl enum
    getUiState(): number {
        return UiStateEnum.uiRulerState;
    }

    // The mouse is moving in this state
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        // Store cursor positions
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;

        // Get selection (will call parent)
        this.setSelected();

        // Do we stay in the current state ?
        if (this.getNextUiState() === this.getUiState()) {
            // Yes !

            // We need the horizontal ruler and it doesn't exist, let's create it
            if (this.horizontalRuler && !GameObjectManager.rulerCreated(false)) {
                GameObjectManager.createRuler(false);
            }
            else {
                // We don't need the horizontal ruler and it exist, delete it
                if (!this.horizontalRuler && GameObjectManager.rulerCreated(false)) {
                    GameObjectManager.deleteRuler(false);
                }
            }

            // We need the vertcial ruler and it doesn't exist, let's create it
            if (this.verticalRuler && !GameObjectManager.rulerCreated(true)) {
                GameObjectManager.createRuler(true);
            }
            else {
                // We don't need the vertical ruler and it exist, delete it
                if (!this.verticalRuler && GameObjectManager.rulerCreated(true)) {
                    GameObjectManager.deleteRuler(true);
                }
            }

            // Draw rulers now
            GameObjectManager.drawRuler(this.cursorPosition);

            // Stay in this state
            return null;
        }
        else {
            // We quit this state, we delete both rulers
            GameObjectManager.deleteRuler(false);
            GameObjectManager.deleteRuler(true);
            // And we leave to next state
            return this.createNextUiState();
        }
    }

    // Called when the mouse hovers a wall in this state, we can select this wall
    mouseHoverWall(wallHovered: Wall[], cursorPosition: math.vec3): boolean {
        // Zoom scale
        var zoom = PlanManager.getInstance().getZoomScale();

        // Check hovered wall to find if a corner is hovered
        for (var i = 0; i < wallHovered.length; i++) {
            // Begin hovered, create a junction point over the begin point
            if (wallHovered[i].isBegin(cursorPosition, SavaneConstants.PositionTolerance + Utils.magnetDistance)) {
                GameObjectManager.createJunctionPoint(new cc.p(wallHovered[i].begin[0] / 10, wallHovered[i].begin[1] / 10), zoom, 'HoverJunctionPoint', wallHovered);
            }
            else {
                // End hovered, create a junction point over the begin point
                if (wallHovered[i].isEnd(cursorPosition, SavaneConstants.PositionTolerance + Utils.magnetDistance)) {
                    GameObjectManager.createJunctionPoint(new cc.p(wallHovered[i].end[0] / 10, wallHovered[i].end[1] / 10), zoom, 'HoverJunctionPoint', wallHovered);
                }
                else {
                    // No corner hovered, we delete the joinction point node
                    GameObjectManager.deleteJunctionPoint('HoverJunctionPoint');
                }
            }
        }
        return true;
    }

    // Called when the mouse leaves a wall in this state
    mouseLeaveHoverWall(wallHovered: Wall[], cursorPosition: math.vec3): boolean {
        // No more corner hovered, we delete the joinction point node
        GameObjectManager.deleteJunctionPoint('HoverJunctionPoint');
        return true;
    }
}
